import request from '@/utils/request'

export function fetchQuestionList(data) { // 获取问卷题目列表
  return request({
    url: '/v1/video/question/list',
    method: 'get',
    params: data
  })
}

export function submitQuestion(data) { // 提交题目信息
  return request({
    url: '/v1/video/question/log-create',
    method: 'post',
    data
  })
}
